import { Button, SuccessMessage, Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { ReconsentConnection } from './getReconsentConnections';

export type RemainingConnections = 'needs-renewing' | 'up-to-date' | 'none';

export const RevokeSuccess = ({
    connection,
    remaining,
    onDone,
    onBackToConnections,
    onConnectBank
}: {
    connection: ReconsentConnection;
    remaining: RemainingConnections;
    onDone: () => void;
    onBackToConnections: () => void;
    onConnectBank: () => void;
}) => {
    return (
        <div className="space-y-l">
            <SuccessMessage size="medium" className="fs-mask dd-privacy-mask">
                {connection.bankName ? (
                    <FormattedMessage
                        id="_.bank_selection_modal.reconsent.revoke_success_heading"
                        defaultMessage="Done – we’ve revoked access to your {bankName} accounts"
                        values={{ bankName: connection.bankName }}
                    />
                ) : (
                    <FormattedMessage
                        id="_.bank_selection_modal.reconsent.revoke_success_heading_unknown_bank"
                        defaultMessage="Done – we’ve revoked access to this account"
                    />
                )}
            </SuccessMessage>

            <Text size="s">
                <FormattedMessage
                    id="_.bank_selection_modal.reconsent.revoke_success_body"
                    defaultMessage="We’ll stop seeing this account’s data. You can reconnect it whenever you like – just log in at your bank."
                />
            </Text>

            <div className="space-y-s">
                <Button
                    variant="primary-rounded"
                    className="w-full"
                    onClick={onDone}
                >
                    <FormattedMessage
                        id="_.bank_selection_modal.done"
                        defaultMessage="Done"
                    />
                </Button>

                {remaining === 'needs-renewing' && (
                    <Button
                        variant="tertiary"
                        className="w-full"
                        onClick={onBackToConnections}
                    >
                        <FormattedMessage
                            id="_.bank_selection_modal.reconsent.revoke_success_back"
                            defaultMessage="Back to your connections"
                        />
                    </Button>
                )}

                {remaining === 'none' && (
                    <Button
                        variant="tertiary"
                        className="w-full"
                        onClick={onConnectBank}
                    >
                        <FormattedMessage
                            id="_.bank_selection_modal.reconsent.revoke_success_connect"
                            defaultMessage="Connect a bank account"
                        />
                    </Button>
                )}
            </div>
        </div>
    );
};
